import { queryListsCreators } from 'modules/campaigns/editor/queries';
import { useGraphql } from 'utils/hooks/useGraphql';

type User = {
  id: string;
  fullName: string;
};

export type ListCreatorNamesById = {
  [id: string]: string;
};

export const useListCreatorNames = () => {
  const {
    data: { emailListsCreators = [] } = {},
  } = useGraphql(queryListsCreators);

  const listCreatorNameById = emailListsCreators.reduce(
    (nameById: ListCreatorNamesById, creator: User) => ({
      ...nameById,
      [creator.id]: creator.fullName,
    }),
    {},
  );

  return listCreatorNameById;
};
